module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t3"
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("Publicado por")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("Dreamspinner Press")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("382 NE 191st Street #88329"), _c('br'), _vm._v("Miami, FL 33179–3899, USA")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('a', {
    attrs: {
      "href": "http://www.dreamspinnerpress.com/",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("http://www.dreamspinnerpress.com/")])])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("Este es un trabajo de ficción. Los personajes, nombres, lugares y sucesos son producto de la imaginación del autor o son usados de manera ficticia; cualquier semejanza con cualquier persona real, viva o muerta, establecimiento, negocio, o eventos reales son pura coincidencia. ")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("Amar significa… No avergonzarse.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("Copyright © 2009 de Andrew Grey")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("Título original: Love means… No shame.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("Diseño de portada por Mara McKennen")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("Traducido por: Saura García")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("Se reservan todos los derechos. Queda prohibida la reproducción de cualquier parte de este libro, o su transmisión en cualquier formato o vía, ya sea electrónica o mecánica, incluyendo fotocopiado, grabado o almacenaje en cualquier soporte o sistema sin el expreso permiso de la Editorial, salvo cuando lo permita la ley. Para solicitar permiso y cualquier otra duda, por favor pónganse en contacto con Dreamspinner Press, 4760 Preston Road, Suite 244–149, Frisco, TX 75034")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('a', {
    attrs: {
      "href": "http://www.dreamspinnerpress.com/",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("http://www.dreamspinnerpress.com/")])])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("Impreso en los Estados Unidos de América.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("Primera Edición.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("Septiembre, 2009")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("Edición eBook en Español")]), _c('span', {
    staticClass: "t4"
  }, [_vm._v(": 978–1–61372–824–6 ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ae2c032","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004.vue
// module id = 63
// module chunks = 0